import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { map, exhaustMap, catchError, withLatestFrom, switchMap } from 'rxjs/operators';
import { AccountService } from '../../account.service';
import { UserActions, UserApiActions } from '../actions/user.actions';
import { Store } from '@ngrx/store';
import { selectUserDetails } from '../selectors/user.selectors';

@Injectable()
export class UserEffects {
    private action$ = inject(Actions);
    private readonly store = inject(Store);
    private userService = inject(AccountService);

    loadUser$ = createEffect(() => {
        return this.action$.pipe(
            ofType(UserActions.loadUser),
            withLatestFrom(this.store.select(selectUserDetails)),
            switchMap(([action, user]) => {
                if (user && action.refresh === false) {
                    return of();
                }
                else {
                    return this.userService.getUserObservable().pipe(
                        map(user => (UserApiActions.retrieveUser(user))),
                        catchError(() => EMPTY)
                    )
                }
            })
        )
    })
}